import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ClassesJoinTrimPipe } from '@shared/pipes/classes-join-trim.pipe';

@Component({
  selector: 'icon',
  templateUrl: './icon.component.html',
  host: {
    class: 'icon'
  },
  providers: [
    ClassesJoinTrimPipe
  ]
})
export class IconComponent implements OnInit, OnChanges {

  @Input() iconName: string = 'home';
  @Input() iconColor: string = null;
  @Input() iconSize: string = null;
  @Input() iconWeight: string = null;

  public iconUseTag: SafeHtml;

  constructor(private sanitizer: DomSanitizer, private _classesJoinTrim: ClassesJoinTrimPipe) { }

  ngOnInit(): void {
    this.iconUseTag = this.buildIconUseTag(this.iconName);
    this.setIconColor(this.iconColor);
    this.setIconSize(this.iconSize);
    this.setIconWeight(this.iconWeight);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.iconName.firstChange) {
      this.iconUseTag = this.buildIconUseTag(changes.iconName.currentValue);
    }
  }

  public setIconColor(color: string) {
    if (color) {
      color = color.toLowerCase();
      switch (color) {
        case 'default':
          this.iconColor = 'icon--default';
          break;
        case 'primary':
          this.iconColor = 'icon--primary';
          break;
        case 'white':
          this.iconColor = 'icon--white';
          break;
        case 'currentcolor':
          this.iconColor = 'icon--currentColor';
          break;
        case 'success':
          this.iconColor = 'icon--success';
          break;
        default:
          this.iconColor = null;
          break;
      }
    } else {
      this.iconColor = null;
    }
  }

  public setIconSize(size: string) {
    if (size) {
      size = size.toLowerCase();
      switch (size) {
        case 'small' || 'is-small':
          this.iconSize = 'is-small';
          break;
        case 'large' || 'is-large':
          this.iconSize = 'is-large';
          break;
        default:
          this.iconSize = null;
          break;
      }
    } else {
      this.iconSize = null;
    }
  }

  public setIconWeight(weight: string): string {
    if (weight) {
      weight = weight.toLowerCase();
      switch (weight) {
        case 'thin':
          this.iconWeight = 'is-thin';
          break;
        case 'bolder':
          this.iconWeight = 'is-bolder';
          break;
        default:
          this.iconWeight = null;
          break;
      }
    } else {
      return null;
    }
  }

  public buildIconUseTag(iconName: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(
      '<use href="assets/icons/Magicons.svg#icon-' + iconName + '"/>'
    );
  }

  public iconClasses(): string {
    var classes = [
      this.iconColor,
      this.iconSize,
      this.iconWeight
    ];
    return this._classesJoinTrim.transform(classes);
  }

}
